export default __webpack_public_path__ + "static/media/cross.2e5bebbb.svg";